import React, { useEffect, useState } from 'react'
import { type BaseRecord, type IResourceComponentsProps, type HttpError, useApiUrl, useNotification } from '@refinedev/core'
import { CustomSearchBar, filterData } from '../../components/shared/CustomSearchBar'

import {
  useTable,
  List,
  EditButton,
  ShowButton,
  DeleteButton,
  ImageField,
  UrlField,
  TagField,
  RefreshButton,
  CreateButton
} from '@refinedev/antd'

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from '@ant-design/icons'

import {
  Table, Space, // Icons,
  Tooltip, Popover, Button, Popconfirm, Switch
} from 'antd'

import {
  compareFn,
  convertSeconds,
  toColor,
  toData,
  toSec,
  stringToData,
  ticketsToColor,
  splitBuyable,
  fetchWithAuth,
  type itemTicket
} from '../../fn'

const {
  // CheckCircleOutlined,
  // CloseCircleOutlined,
  // MinusCircleOutlined,
  DownCircleOutlined,
  DownCircleFilled,
  UpCircleOutlined,
  UpCircleFilled,
  ShoppingOutlined,
  ShoppingFilled,
  ShoppingCartOutlined,
  NotificationOutlined,
  NotificationFilled,
  // PoweroffOutlined,
  // SearchOutlined,
  NumberOutlined,
  // IdcardOutlined,
  ScissorOutlined
} = Icons

export interface obj {
  platform: string
  id: number
  eventId: string
  eventName: string
  photo: string
  eventDate: string
  artist: string
  location: string
  url: string
  frequency: 30
  lastScan: number
  globalLessThen: string
  modus: any
  modusArr: any
  lastAlert: 1706253300.601
  tickets: Record<string, itemTicket>
  map: true
  disabled?: boolean
}

const img = (item: obj): any => {
  return (
    <>
      <div>
        <ImageField
          style={{ maxWidth: '100px' }}
          value={item?.photo?.includes('http') ? item?.photo : `https://teddy1.mywire.org/${item?.photo}`}
        />
      </div>
    </>
  )
}

const print = (record: Record<string, obj>, fn: (a: obj, record: Record<string, obj>) => any, once = false, fansaleLoop = ''): any => {
  const result = []
  for (const platform of Object.keys(record ?? {})) {
    if (platform === 'id') continue
    if (platform === 'fansaleArr' && !fansaleLoop) continue
    if (platform === 'fansaleArr' && fansaleLoop) {
      for (const fansaleItem of Object.values(record?.[platform])) {
        result.push(fn(fansaleItem, record))
        if (fansaleLoop === 'once') break
      }
    } else {
      if (record?.[platform]) result.push(fn(record?.[platform], record))
    }

    if (once) break
  }
  return result
}

const artist = (item: obj): any => {
  // eslint-disable-next-line operator-linebreak
  return item ?
    <>
      <div style={{ minWidth: '220px', maxWidth: '300px' }}>

        <h3>
          🎫 {item?.artist}
        </h3>

        <div>
          <b>
            📍 {item?.location}
          </b>
        </div>

        <div>
          🗓️ {item?.eventDate || item?.url}
        </div>

      </div>
    </>
    : null
}

export const imgPlatform = (item: { platform: string }, link = ''): any => {
  const img = (
    <img
      style={{ maxWidth: 22, marginRight: 5 }}
      title={item?.platform}
      src={`https://teddy1.mywire.org/img/${item?.platform}.png`}
    />
  )
  const a = (<a href={link}>{img}</a>)
  return link ? a : img
}
const link = (item: obj): any => {
  // eslint-disable-next-line operator-linebreak
  return item ?
    <div>
      {imgPlatform(item)}
      {item?.url ? (<UrlField style={{ maxWidth: 22, marginRight: 5 }} target='_blank' value={item?.url}>🌐</UrlField>) : null}
      {item?.eventId ? (<TagField color='blue' value={item?.eventId} />) : null}

      <span>
        {item?.map
          ? <Tooltip title='Scansione in modalita mappa'><span>🗺 Mappa</span></Tooltip>
          : <Tooltip title='Scansione in modalita lista'><span>📄Lista</span></Tooltip>}
      </span>
      <span style={{ marginLeft: 10 }}>
        <Tooltip title='GlobalLessThen filtra i risultati in questo modo: dato un aggiornameto Old => New, sia con Old che New minore di X viene notificato '>
          {item?.globalLessThen ? <TagField value={'🌍 ' + String(item?.globalLessThen)} color='black' icon={<ScissorOutlined />} style={{ fontWeight: 'bold' }} /> : ''}
        </Tooltip>
      </span>

    </div>
    : null
}

const rowPlatformKeys = (record: Record<string, any>): string[] =>
  Object.keys(record ?? {}).filter(k => k !== 'id' && k !== 'fansaleArr' && record[k])

export const allPlatformsDisabled = (record: Record<string, any>): boolean => {
  const ks = rowPlatformKeys(record)
  return ks.length > 0 && ks.every(k => record[k]?.disabled === true)
}

const TicketsCell: React.FC<{ record: Record<string, any> }> = ({ record }) => {
  const [expanded, setExpanded] = useState(false)
  let hiddenCount = 0
  const blocks = rowPlatformKeys(record).map((p) => {
    const item = record[p]
    const all = Object.values(item?.tickets ?? {})
    const { buyable, hidden } = splitBuyable(all as itemTicket[], item.modus)
    hiddenCount += hidden.length
    const toRender = (expanded ? all : buyable) as any[]
    return (
      <div key={p} style={item.disabled ? { opacity: 0.45 } : undefined}>
        {toRender.map((sector: any, index: number) => {
          const eventimTickets = item?.platform === 'eventim' ? all : null
          const { tags, tagArea, tagNumber, tagSingle, tagCouple } =
            ticketsToColor(sector, item.globalLessThen, item.modus, eventimTickets as any)
          return (
            <React.Fragment key={index}>
              <div>{imgPlatform(item)}{tags}{tagArea}{tagNumber}{tagSingle}{tagCouple}</div>
            </React.Fragment>
          )
        })}
      </div>
    )
  })
  return (
    <>
      {blocks}
      {(expanded || hiddenCount > 0)
        ? (
          <a onClick={() => { setExpanded(e => !e) }} style={{ cursor: 'pointer', fontSize: 12 }}>
            {expanded ? '▾ Mostra solo da comprare' : `▸ Mostra tutti i settori (${hiddenCount})`}
          </a>
          // eslint-disable-next-line indent, @typescript-eslint/indent
          )
        : null}
      <br />
    </>
  )
}

export const printTable = (tableProps: any, filteredData?: any, opts?: { toggleDisabled?: (record: any, checked: boolean) => void }): any => {
  return (
    (
      <Table
        {...tableProps}
        rowKey='id'
        onRow={(record: any) => ({ style: allPlatformsDisabled(record) ? { opacity: 0.5 } : undefined })}
      >
        <Table.Column
          dataIndex='id'
          render={(value: string, record: Record<string, obj>, index: number) => (
            <>
              {print(record, img, true)}
            </>
          )}
          title='🖼 Photo'
        />
        <Table.Column
          dataIndex={['artist']}
          key='artist'
          render={(v: any, record: Record<string, obj>, index: any) => (
            <>
              {allPlatformsDisabled(record) ? <TagField color='default' value='⏸ disabilitato' /> : null}
              {print(record, artist, true)}
              {print(record, link, false, 'once')}
            </>
          )}
          title='🎫 Event'
          sorter={{ compare: compareFn('eventDate', stringToData) }}
        />
        <Table.Column
          dataIndex='tickets'
          render={(value: any[], record: Record<string, obj>) => (
            <TicketsCell record={record} />
          )}
          title={
            <Popover
              content={
                <div>
                  <p><TagField value='' color='cyan' icon={<NotificationFilled />} />solo notifica</p>
                  <p><TagField value='' color='cyan' icon={<NotificationOutlined />} />solo notifica disabilitata da filtro qta</p>
                  <p><TagField value='⚫️' color='default' icon={<NotificationOutlined />} /> Disabilitato manualmente</p>
                  <p><TagField value='🌍' color='default' icon={<NotificationOutlined />} /> Disabilitato da GlobalLessThan Globale</p>
                  <p><TagField value='2' color='purple' icon={<DownCircleFilled />} style={{ fontWeight: 'bold', minWidth: '40px' }} /> filtro qta minima attivo</p>
                  <p><TagField value='2' color='purple' icon={<DownCircleOutlined />} style={{ minWidth: '40px' }} />filta qta minima non attivo</p>
                  <p><TagField value='100' color='purple' icon={<UpCircleFilled />} style={{ fontWeight: 'bold', minWidth: '40px' }} /> filtro qta massima attivo</p>
                  <p><TagField value='100' color='purple' icon={<UpCircleOutlined />} style={{ minWidth: '40px' }} />filta qta massima non attivo</p>
                  <p><TagField value='10' color='gold' icon={<ShoppingCartOutlined />} style={{ fontWeight: 'bold' }} />auto carrella fino a 10 biglietti</p>
                  <p><TagField value='10' color='gold' icon={<ShoppingCartOutlined />} style={{ fontWeight: 'bold' }} />auto carrella disabilitato da filtro qta</p>
                  <p><TagField value='20' color='green' icon={<ShoppingFilled />} style={{ fontWeight: 'bold' }} />auto compra fino a 20 biglietti</p>
                  <p><TagField value='20' color='green' icon={<ShoppingOutlined />} style={{ fontWeight: 'bold' }} />auto compra disabilitato da filtro qta</p>
                  <p><TagField value='Parterre A € 287,50' color='red' />Settore esaurito</p>
                  <p><TagField value='Parterre A € 287,50' color='green' />Settore disponibile</p>
                  <p><TagField value='Parterre A € 287,50' color='default' />Settore disabilitato da filtro</p>
                  <p><TagField value='0' color='red' icon={<NumberOutlined />} />Posti non disponibili</p>
                  <p><TagField value='327' color='green' icon={<NumberOutlined />} />Posti disponibili</p>
                  <p><TagField value='🛑' color='red' icon={<NumberOutlined />} />Settore cancellato</p>
                </div>
              }
              title='Legenda'
            >
              <span>🎟 Tickets ❔</span>
            </Popover>
          }
        />
        <Table.Column
          dataIndex='frequency'
          title='⏳ Frequency'
          render={(value: any, record: Record<string, obj>) => (
            <>
              {print(record, (item) => <div>{imgPlatform(item)}⏳ {item.frequency}</div>)}
            </>
          )}
        />
        <Table.Column
          dataIndex='lastScan'
          render={(value: any, record: Record<string, obj>) => (
            <>
              {print(
                record,
                (item) =>
                  <div style={{ color: toColor(item?.lastScan), minWidth: '100px' }}>{imgPlatform(item)}⏱
                    {
                      // eslint-disable-next-line multiline-ternary
                      (

                        <Popover
                          content={
                            <>
                              <div style={{ fontWeight: 'bold' }}>{item.id}</div>
                              <div style={{ color: toColor(item?.lastScan), fontWeight: 'bold' }}>{imgPlatform(item)}⏱{item?.lastScan ? toData(item?.lastScan) : 'Never'}</div>
                            </>
                          }
                          title='Data Ultima Scansione'
                        >
                          <b>
                            {item?.lastScan ? convertSeconds(toSec(item?.lastScan)) : 'Never'}
                          </b>
                        </Popover>

                      )

                    }
                  </div>
                , false,
                'once'
              )}
            </>

          )}
          title='⏱ Last Scan'
          sorter={{ compare: compareFn('lastScan') }}
        />
        <Table.Column
          dataIndex='lastAlert'
          render={(value: number, record: Record<string, obj>) => (
            <>
              {print(
                record,
                (item) =>
                  <div>{imgPlatform(item)}⚠️
                    <Popover
                      content={
                        <>
                          <div style={{ fontWeight: 'bold' }}>{item.id}</div>
                          <div style={{ fontWeight: 'bold' }}>{imgPlatform(item)}⚠️{item.lastAlert ? toData(item.lastAlert) : 'Never'}</div>
                        </>
                      }
                      title='Data Ultimo Alert'
                    >
                      <b>
                        {item.lastAlert ? convertSeconds(toSec(item.lastAlert)) : 'Never'}
                      </b>
                    </Popover>
                  </div>
                , false,
                '' /* was 'fansale' — keyword last-alert loop disabled */
              )}
            </>

          )}
          title='⚠️ Last Alert'
          sorter={{ compare: compareFn('lastAlert') }}
        />
        <Table.Column
          dataIndex='id'
          key='disabled'
          title={
            <Tooltip title='Disabilita evento: non viene scansionato, ma conserva i dati raccolti'>
              <span>⏸ Off</span>
            </Tooltip>
          }
          render={(id, record: BaseRecord) => (
            opts?.toggleDisabled
              ? (
                <Switch
                  size='small'
                  checkedChildren='⏸'
                  checked={allPlatformsDisabled(record as any)}
                  onChange={(checked) => { opts.toggleDisabled?.(record, checked) }}
                />
                // eslint-disable-next-line indent, @typescript-eslint/indent
                )
              : (allPlatformsDisabled(record as any) ? <TagField color='default' value='⏸' /> : null)
          )}
        />
        {
          // eslint-disable-next-line multiline-ternary
          <Table.Column
            dataIndex='id'
            render={(id, record: BaseRecord) => (
              <>
                <div style={{ paddingBottom: 2, paddingTop: 2 }}>
                  <Space>
                    <img
                      style={{ maxWidth: 22, marginRight: 5 }}
                      title='Global Item'
                      src='https://teddy1.mywire.org/favicon.ico'
                    />
                    <ShowButton
                      hideText
                      recordItemId={id}
                      size='middle'
                    />
                    <EditButton
                      hideText
                      recordItemId={id}
                      size='middle'
                    />
                    <DeleteButton
                      hideText
                      recordItemId={id}
                      size='middle'
                    />
                  </Space>
                </div>
                {
                  print(record, (item: obj): any =>
                    <div style={{ paddingBottom: 2, paddingTop: 2 }}>
                      <Space>
                        {imgPlatform(item)}
                        <ShowButton
                          resource={`it-${item.platform}`}
                          hideText
                          recordItemId={item.id}
                          size='middle'
                        />

                        <EditButton
                          resource={`it-${item.platform}`}
                          hideText
                          recordItemId={item.id}
                          size='middle'
                        />

                        <DeleteButton
                          resource={`it-${item.platform}`}
                          hideText
                          recordItemId={item.id}
                          size='middle'
                        />
                      </Space>
                    </div>)
                }
              </>
            )}
            title='🕹 Actions'
          />
        }
      </Table>
    )
  )
}

export const CountryList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, tableQuery } = useTable<obj, HttpError, { q: string }>({
    syncWithLocation: true,
    pagination: {
      mode: 'off'
    }
  })

  const { open } = useNotification()
  const API_URL = useApiUrl()

  const toggleDisabled = async (record: any, checked: boolean): Promise<void> => {
    const country = window.location.pathname.split('/').pop() ?? 'it'
    // 'fansale' is the deprecated keyword platform whose edit endpoint expects a
    // different body shape — exclude it from the disable toggle.
    const platforms = rowPlatformKeys(record).filter((p) => p !== 'fansale')
    try {
      await Promise.all(platforms.map(async p =>
        await fetchWithAuth(`${API_URL}/${country}-${p}/${String(record[p].id)}`, { method: 'PATCH', body: { disabled: checked } })))
      open?.({ message: checked ? 'Evento disabilitato' : 'Evento riabilitato', type: 'success' })
      await tableQuery.refetch()
    } catch (error) {
      open?.({ message: 'Errore aggiornando lo stato evento', type: 'error' })
    }
  }

  const [query, setQuery] = useState<any>()
  const updatedTableProps = {
    ...tableProps,
    dataSource: filterData(tableProps.dataSource, query)
  }

  const [hasPastItems, setHasPastItems] = useState(false)

  useEffect(() => {
    const checkPastItems = (): boolean => {
      if (!updatedTableProps.dataSource) return false
      const now = new Date()
      now.setHours(0, 0, 0, 0)
      return updatedTableProps.dataSource.some((record: any) => {
        for (const key of Object.keys(record)) {
          if (key === 'id' || key === 'fansaleArr') continue
          if (record[key]?.eventDate) {
            const ms = stringToData(record[key].eventDate)
            if (ms > 0 && ms < now.getTime()) return true
            break
          }
        }
        return false
      })
    }
    setHasPastItems(checkPastItems())
  }, [updatedTableProps.dataSource])

  const handleDeletePast = async (): Promise<void> => {
    const country = window.location.pathname.split('/').pop() ?? 'it'
    try {
      const data = await fetchWithAuth(`${API_URL}/country/${country}/delete-past`, {
        method: 'DELETE'
      })

      if (data?.error) {
        open?.({ message: 'Errore eliminazione eventi passati!', description: data.error, type: 'error' })
      } else {
        open?.({ message: 'Eventi passati eliminati! (' + String(data?.deletedCount ?? 0) + ')', type: 'success' })
      }

      await tableQuery.refetch()
    } catch (error) {
      console.error('Failed to delete past events:', error)
      open?.({ message: 'Errore eliminazione eventi passati!', type: 'error' })
    }
  }

  const deletePastButton = (
    <Popconfirm
      title='Sei sicuro di voler eliminare tutti gli eventi passati?'
      onConfirm={() => { void handleDeletePast() }}
      okText='Sì'
      cancelText='No'
    >
      <Button
        type='primary'
        danger={hasPastItems}
        disabled={!hasPastItems}
        onClick={(e) => { e.stopPropagation() }}
        size='large'
      >
        Elimina Eventi Passati
      </Button>
    </Popconfirm>
  )

  return (
    <List
      headerButtons={
        <>
          {deletePastButton}
          <CustomSearchBar
            onFilter={setQuery}
          />
          <RefreshButton
            onClick={() => { window.location.reload() }}
            size='large'
          />
          <CreateButton
            size='large'
            type='primary'
          />
        </>
      }
      title={'🤖 ' + window.location.pathname.replace('/', '').toUpperCase()}
    >
      {printTable(updatedTableProps, query, { toggleDisabled: (record, checked) => { void toggleDisabled(record, checked) } })}
      <div style={{ marginTop: 16 }}>
        {deletePastButton}
      </div>
    </List>
  )
}
